const KEY_NAME = "EXCHANGE_URL";

export const getExchangeUrlLocalStorage = (): string | null => {
  const res = window.localStorage.getItem(KEY_NAME);
  return res ?? null;
}

export const setExchangeUrlLLocalStorage = (newValue: string) => {
  window.localStorage.setItem(KEY_NAME, newValue);
}

export const removeExchangeUrlLLocalStorage = () => {
  window.localStorage.removeItem(KEY_NAME);
}


